module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "on-mobile"
  }, [_c('about-content', {
    attrs: {
      "isMobile": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1e074344!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/OnMobile/OnMobile.vue
// module id = 266
// module chunks = 0